"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const BackArrow = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 24 24" },
        react_1.default.createElement(react_native_svg_1.G, { fill: color, "fill-rule": "evenodd" },
            react_1.default.createElement(react_native_svg_1.Path, { d: "M15.777 4.63a.749.749 0 0 1 0 1.058L9.446 12.02l6.356 6.357a.749.749 0 1 1-1.059 1.059L7.89 12.583l-.01-.01a.749.749 0 0 1-.024-1.082l6.862-6.862a.749.749 0 0 1 1.06 0z" }))));
};
BackArrow.defaultProps = {
    color: '#111111',
    width: 24,
    height: 24,
};
exports.default = react_1.default.memo(BackArrow);
